import { Loading } from 'element-ui';

export default {
  bind(el, binding) {
    // 默认加载文字
    const loadingText = binding.arg || '数据加载中...';
    
    // 创建 loading 实例
    const loadingInstance = Loading.service({
      target: el,
      background: 'rgba(255, 255, 255, 0.7)',
      text: loadingText,
    });

    // 将 loading 实例挂载到 el 上，方便后续操作
    el.__loadingInstance__ = loadingInstance;

    // 如果 binding.value 为 true, 则显示 loading，否则关闭 loading
    if (binding.value) {
      loadingInstance.close();
    }
  },
  update(el, binding) {
    const loadingInstance = el.__loadingInstance__;
    
    // 当 binding.value 为 false 时，打开 loading，否则关闭
    if (binding.value) {
      loadingInstance.close();
    } else {
      loadingInstance.open();
      // 如果 binding.arg 发生变化（即传入的自定义文本），更新 loading 文字
      loadingInstance.text = binding.arg || '数据加载中...';
    }
  },
  unbind(el) {
    const loadingInstance = el.__loadingInstance__;
    if (loadingInstance) {
      loadingInstance.close();
    }
  }
};
